import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, NgForm, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { BoardDocumentsResponseModel } from "src/app/model/BoardDocumentsResponseModel";
import { BoardDocumentsService } from "src/app/services/board-documents.service";
import { ImportMasterService } from "src/app/services/import-master.service";
import { MasterService } from "src/app/services/master.service";

@Component({
  selector: "app-secure-import-master",
  templateUrl: "./upload-tenement-master.component.html",
  styleUrls: ["./upload-tenement-master.component.scss"],
})
export class UploadTenementMasterComponent implements OnInit {
  isLoading = false;
  displayButton = false;

  boardKey: number;
  lotteryKey: number;
  lotteries: { [key: number]: string };
  uploadMasterTypes: string[];
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  selectedFile: File;
  showDataHere: any = "";
  boards: { [key: number]: string };
  successMessage: string;
  filename: string;
  errorMessage: String;
  errorFile: string;
  boardDocumentDetail: BoardDocumentsResponseModel;
  masterType = "TENEMENT";

  @ViewChild("localForm") localForm: NgForm;

  constructor(
    private router: Router,
    private masterService: MasterService,
    private importMasterService: ImportMasterService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private boardDocumentsService: BoardDocumentsService
  ) {}

  ngOnInit(): void {
    this.boardDocumentsService.initBoardDocumentsForm().subscribe(
      (data: any) => {
        this.isLoading = false;
        if (data.status === "SUCCESS") {
          this.boards = data.boards;
          this.route.params.subscribe((params: Params) => {});
        } else {
          this.masterService.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.isLoading = false;
      }
    );

    this.form = new FormGroup({
      boardKey: new FormControl(null, Validators.required),
      // lotteryKey: new FormControl("", Validators.required),
      // importMasterType: new FormControl("", Validators.required),
      file: new FormControl(null, Validators.required),
      // showDataHere: new FormControl(),
    });
  }

  async onChangeBoard(boardId: any) {
    this.boardKey = boardId.key;
    // this.isLoading = true;
    this.masterService.getLotteriesForBoard(this.boardKey).subscribe(
      (data) => {
        if (data.status === "SUCCESS") {
          this.displayButton = true;
          this.lotteries = data.lotterylist;
        } else {
          this.importMasterService.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.importMasterService.errorToast(
          error?.error?.message || error?.error?.errorMessage
        );
        this.isLoading = false;
      }
    );
  }

  onChangeLottery(lotteryId: any) {
    this.lotteryKey = lotteryId.key;
  }

  onFileSelect(event) {
    this.selectedFile = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.readAsText(this.selectedFile);
    const fileName = this.selectedFile.name;

    const fileNameWithoutExtension = fileName.replace(/\.[^/.]+$/, "");
    this.filename = fileNameWithoutExtension;
    reader.onload = (e) => {
      let csv: string = reader.result as string;
      let allTextLines = csv.split(/\r|\n|\r/);
      let headers = allTextLines[0].split(",");
      let lines = [];

      for (let i = 0; i < allTextLines.length; i++) {
        // split content based on comma
        let data = allTextLines[i].split(",");

        if (data.length === headers.length) {
          let tarr = [];
          for (let j = 0; j < headers.length; j++) {
            tarr.push(data[j]);
          }

          // log each row to see output
          console.log(tarr);
          lines.push(tarr);
        }
      }

      this.showDataHere = lines[0].join("\n");
      if (this.showDataHere.includes("Project Code")) {
        this.showDataHere;
      } else {
        this.errorToast("Only CSV Files are Allowed");
        this.localForm.resetForm({
          file: null,
        });
        this.selectedFile = null;
        this.showDataHere = null;
      }
    };
  }

  showBDD(o1: any, o2: any) {
    if (o1 && o2 && o1.key == o2.key) {
      return o1.value;
    } else {
      return "";
    }
  }

  onSubmit() {
    if (this.form.valid) {
      if (this.selectedFile) {
        this.isSubmitDisabled = true;
        this.isLoading = true;
        const reader = new FileReader();
        reader.readAsDataURL(this.selectedFile);
        reader.onload = () => {
          this.masterService
            .saveMasterDetails({
              boardId: this.boardKey,
              lotteryEventId: this.lotteryKey,
              base64Data: reader.result,
              fileName: this.filename,
            })
            .subscribe(
              (data: any) => {
                if (data.status === "SUCCESS") {
                  this.isSubmitDisabled = false;
                  this.isLoading = false;
                  this.form.get("boardKey").setValue("");
                  this.selectedFile = null;
                  this.router.navigate([
                    "/secure",
                    "engineer-tenement-upload",
                    "list",
                  ]);
                  this.masterService.successToast("Saved Successfully");
                  // window.location.reload();
                } else {
                  this.isSubmitDisabled = false;
                  this.isLoading = false;
                  this.masterService.errorToast(data.errorMessage);
                }
              },
              (error) => {
                this.isLoading = false;
                console.log(error);
                this.masterService.errorToast(
                  error.error.errorMessage,
                  5 * 1000
                );
              }
            );
        };
      } else {
        this.masterService.errorToast("Please Select CSV File");
        this.isSubmitDisabled = false;
      }
    } else {
      this.masterService.errorToast("Please Select all Required Fields ");
      this.isSubmitDisabled = false;
    }
  }

  downloadTemplate() {
    // if (this.form.value.importMasterType) {
    this.masterService
      .downloadTemplate(this.masterType)
      .subscribe((data: any) => {
        if (data.status === "SUCCESS") {
          this.downloadFile(data.data, this.masterType + ".csv");
        } else {
          this.importMasterService.errorToast(data.errorMessage);
        }
      });
    // }
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  downloadFile(base64: string | ArrayBuffer, fileName: string) {
    const src = `data:text/csv;base64,${base64}`;
    const link = document.createElement("a");
    link.href = src;
    link.download = fileName;
    link.click();

    link.remove();
  }
}
